export default __webpack_public_path__ + "static/media/error_Charges.28170d88.svg";